import { Job } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

var steps = {
  "1063": { //Tree Removal
    "steps": [
      {
        "title": {
          "text": "Job Details",
          "icon": "ficon-quotes"
        },
        "questions": [
          {
            "type": "Radio",
            "label": "Is this a residential or commercial job?",
            "jobDescriptionKey": "Residential or Commercial",
            "validation": {
              "groupName": "residential_commercial",
              "message": "Please choose the type of tree removal required.",
            },
            "options": [
              {
                "value": "This is a Residential job",
                "text": "Residential",
              },
              {
                "value": "This is a Commercial job",
                "text": "Commercial",
              }
            ]
          }
        ]
      },
      {
        "title": {
          "text": "Job Details",
          "icon": "ficon-quotes"
        },
        "questions": [
          {
            "type": "Checkbox",
            "label": "What specific tree service do you need?",
            "jobDescriptionKey": "Specific tree service",
            "validation": {
              "groupName": "specific_tree_service",
              "message": "Please select the specific tree service you need."
            },
            "options": [
              {
                "value": "Tree Trimming",
                "text": "Tree Trimming"
              },
              {
                "value": "Stump Grinding",
                "text": "Stump Grinding"
              },
              {
                "value": "Complete Removal",
                "text": "Complete Removal"
              },
              {
                "value": "Land Clearing",
                "text": "Land Clearing"
              },
              {
                "value": "Reshaping",
                "text": "Reshaping"
              },
              {
                "value": "Other",
                "text": "Other"
              }
            ]
          }
        ]
      }
    ]
  }
}

Job.Questions = $.extend(Job.Questions, steps)
